module.exports = __webpack_public_path__ + "media/impact-4.b06daec1.webm";